import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { ShareButton } from '../ui/ShareButton'

export const ReferralShareButton: FC<{
  url: string
  className?: string
  disabled?: boolean
  onSuccess?: () => void
  onError?: (error: Error) => void
}> = ({ className, disabled, onSuccess, onError, url }) => {
  const { formatMessage } = useIntl()

  return (
    <ShareButton
      url={url}
      text={formatMessage({
        id: 'bonus.shareText',
        defaultMessage: '🎁 Присоединяйся к VoteBox и получи бонусы!',
      })}
      className={className}
      disabled={disabled}
      onSuccess={onSuccess}
      onError={onError}
    />
  )
}
